import { Link, useMatches } from 'react-router-dom'

import { cn } from '@/lib/utils'

type BreadcrumbProps = ReturnType<typeof useMatches>[0] & {
  handle: {
    breadcrumb: {
      icon?: JSX.Element
      title: string
    }
  }
}

function Breadcrumb() {
  const matches = useMatches() as unknown as BreadcrumbProps[]
  const breadcrumbs = matches.filter((match) => match.handle?.breadcrumb)

  return (
    <ol className="flex items-center gap-x-1">
      {breadcrumbs.map(({ pathname, handle: { breadcrumb } }, index) => (
        <li
          className="flex items-center gap-x-1 before:text-xs before:font-medium before:text-gray-500 before:content-['/'] first:before:content-none last:font-semibold"
          key={index}
        >
          <Link
            className={cn(
              'flex items-center rounded text-sm outline-none hover:text-sky-400 focus-visible:ring-2 focus-visible:ring-gray-300 active:text-sky-700',
              index === 0 ? 'gap-x-2' : 'gap-x-0.5',
            )}
            to={pathname}
          >
            <div>{breadcrumb.icon}</div>
            {breadcrumb.title.toUpperCase()}
          </Link>
        </li>
      ))}
    </ol>
  )
}

export { Breadcrumb }
